import axios from '../../../axios';

export type ServiceResponse = {
  id: number;
  name: string;
  platform: string;
  created: string;
};

export default async function getUserList(): Promise<ServiceResponse[]> {
  let res = await axios.get(`${process.env.REACT_APP_BASE_URL}/user-list`);
  return res.data;
}
